import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { ModalProps } from "types/utils/modal";
import { pluralize } from "utils/pluralize";

export const DeleteConfirmationModal = ({
  isOpen,
  close,
  isLoading,
  confirm,
  itemCount = 0,
  type,
}: ModalProps & {
  isLoading: boolean;
  confirm: () => void;
  itemCount?: number;
  type: "SINGLE" | "MULTIPLE";
}) => {
  const isSingleDelete = type === "SINGLE";

  const title = isSingleDelete
    ? "Permanently delete this file?"
    : `Permanently delete ${pluralize(itemCount, "file", "files", false)}?`;

  return (
    <Modal.Root open={isOpen} onOpenChange={close}>
      <Modal.Content size="small">
        <StatusModal type="danger" title={title}>
          <div className="t-text-body-sm t-text-text-30">
            The selected files will be permanently deleted and cannot be
            recovered.
          </div>
        </StatusModal>
        <Modal.FooterButtonGroup>
          <Modal.RawClose asChild>
            <Button>Cancel</Button>
          </Modal.RawClose>
          <Button
            isLoading={isLoading}
            disabled={isLoading}
            customType="danger"
            onClick={confirm}
          >
            Delete permanently
          </Button>
        </Modal.FooterButtonGroup>
      </Modal.Content>
    </Modal.Root>
  );
};
